import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import bowser from 'bowser';
import { Environment, getRegion, OptimizelyAttributes, OptimizelyDeployEnv } from '@chegg/commerce-utils';
import { captureError, Severity } from '@chegg/observability';
import { getCvidCookie, getIdTokenCookie } from '@chegg/utils';
import { CW_TEAM_NAME } from '../constants/AppConstants';
/**
 * Parses the JWT token and returns the Chegg user UUID
 * @param token
 * @returns the decoded CheggJwt object if successful, or undefined if an error occurs during parsing
 */
export function isoParseIdTokenJWT(token) {
  try {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace('-', '+').replace('_', '/');
    return JSON.parse(window.atob(base64));
  } catch (error) {
    captureError({
      error: error,
      location: 'isoParseIdTokenJWT',
      severity: Severity.ERROR
    }, {
      teamName: CW_TEAM_NAME
    });
    return undefined;
  }
}

/**
 * Retrieves Chegg user UUID from the id_token cookie
 * @returns the Chegg user UUID if successful or undefined if cookie is not present or UUID cannot be extracted
 */
export var getCheggUserUuidFromCookie = function getCheggUserUuidFromCookie() {
  var _isoParseIdTokenJWT;
  var jwt = getIdTokenCookie();
  if (!jwt) {
    return undefined;
  }
  return (_isoParseIdTokenJWT = isoParseIdTokenJWT(jwt)) === null || _isoParseIdTokenJWT === void 0 ? void 0 : _isoParseIdTokenJWT.sub;
};

/**
 * Tracks an Optimizely event
 * @param options
 */
export var trackOptimizely = function trackOptimizely(options) {
  var _parser$browser, _parser, _parser$os, _parser2, _parser$platform, _parser3;
  var optimizelyClient = options.optimizelyClient,
    eventTags = options.eventTags,
    eventKey = options.eventKey,
    trackAttributes = options.trackAttributes;
  var parser = null;
  if (typeof window !== 'undefined') {
    parser = bowser.parse(window.navigator.userAgent);
  }
  var browser = (_parser$browser = (_parser = parser) === null || _parser === void 0 ? void 0 : _parser.browser) !== null && _parser$browser !== void 0 ? _parser$browser : {};
  var os = (_parser$os = (_parser2 = parser) === null || _parser2 === void 0 ? void 0 : _parser2.os) !== null && _parser$os !== void 0 ? _parser$os : {};
  var platform = (_parser$platform = (_parser3 = parser) === null || _parser3 === void 0 ? void 0 : _parser3.platform) !== null && _parser$platform !== void 0 ? _parser$platform : {};
  var country = trackAttributes.country,
    externalId = trackAttributes.externalId,
    productFamily = trackAttributes.productFamily,
    checkoutAction = trackAttributes.checkoutAction,
    environment = trackAttributes.environment,
    currency = trackAttributes.currency,
    hasMops = trackAttributes.hasMops,
    referrer = trackAttributes.referrer;
  if (optimizelyClient) {
    var _platform$type, _browser$name, _objectSpread2, _getCvidCookie;
    var eventAttributes = _objectSpread(_objectSpread({}, optimizelyClient.user.attributes), {}, (_objectSpread2 = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_objectSpread2, OptimizelyAttributes.IS_MOBILE, String(((_platform$type = platform.type) === null || _platform$type === void 0 ? void 0 : _platform$type.toLowerCase()) === 'mobile')), OptimizelyAttributes.BROWSER, (_browser$name = browser.name) !== null && _browser$name !== void 0 ? _browser$name : ''), OptimizelyAttributes.BROWSER_VERSION, browser.name && browser.version ? "".concat(browser.name, " ").concat(browser.version) : ''), OptimizelyAttributes.OS, os.name && os.version ? "".concat(os.name, " ").concat(os.version) : ''), OptimizelyAttributes.COUNTRY, country !== null && country !== void 0 ? country : ''), OptimizelyAttributes.PRODUCT_ID, externalId), OptimizelyAttributes.DEPLOY_ENV, environment === Environment.STAGING || environment === Environment.PRODUCTION ? OptimizelyDeployEnv.PRODUCTION : OptimizelyDeployEnv.DEVELOPMENT), OptimizelyAttributes.CURRENCY, currency), OptimizelyAttributes.PRODUCT_FAMILY, productFamily), OptimizelyAttributes.CHECKOUT_ACTION, checkoutAction !== null && checkoutAction !== void 0 ? checkoutAction : 'JOIN'), _defineProperty(_defineProperty(_defineProperty(_objectSpread2, OptimizelyAttributes.HAS_PAYMENT_METHOD, hasMops ? String(hasMops) : ''), OptimizelyAttributes.REFERRER, referrer !== null && referrer !== void 0 ? referrer : ''), OptimizelyAttributes.REGION, getRegion(country || ''))));
    var userId = (_getCvidCookie = getCvidCookie()) !== null && _getCvidCookie !== void 0 ? _getCvidCookie : 'no-cvid';
    optimizelyClient.track(eventKey, userId, eventAttributes, eventTags);
    var userUuid = getCheggUserUuidFromCookie();
    if (userUuid) {
      optimizelyClient.track(eventKey, userUuid, eventAttributes, eventTags);
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/dropin-payments/dist/esm/utils/OptimizelyUtil.js
// module id = 1525
// module chunks = 11